module.exports = __webpack_public_path__ + "static/media/to-gmail.09700e96.svg";